import { useContext } from "react";
import { ModalContext } from "../../contexts/ModalContext";
import { columnsReport as columns } from "../../constants/columnsModal";
export default function useTotal(){

    const { result: data , selection } = useContext(ModalContext)

    
    const total = {}

    data.map((el, index) => {
        Object.keys(el).map(key => {
            if(key !== "valor_original" && key !==  "saldo" && !!el[key]){
                if(!total[key]?.values?.find(val => val == el[key]) && Number.isInteger(selection.select.find((item, i) => item == el.id))){
    
                    const arrValues = Array.isArray(total[key]?.values) ? total[key]?.values : []
                    arrValues.push(el[key])
                    if(total[key]?.values ){
    
                        total[key].values = [...arrValues]
                    } else {
                        total[key] = {values: [...arrValues]}
                    }
                }
            } else if(!!el[key] && Number.isInteger(selection.select.find((item, i) => item == el.id))) {
                if(total[key]?.total){
                    total[key].total = (Number(total[key].total) + Number(el[key]))
                } else {
                    total[key] = {total: el[key]}
                }
            } 
        })
    })

    const columnGroupingModel = columns.map(col => {

        if (col.field == 'CNPJ') {
            return {
                headerAlign: "center",
                headerName: 'Total',
                groupId:col.field ,
                children: [{ field: 'CNPJ' }],
            }
        }
        // if (col.field == 'devedor') {
        //     return {
        //         headerAlign: "center",
        //         groupId:col.field ,
        //         headerName: total?.devedor?.values ? String(total?.devedor?.values?.length) : '0',
        //         children: [{ field: 'devedor' }],
        //     }
        // }
        // if (col.field == 'contrato') {
        //     return {
        //         headerAlign: "center",
        //         groupId:col.field ,
        //         headerName: total?.contrato?.values ? String(total?.contrato?.values?.length) : '0',
        //         children: [{ field: 'contrato' }],
        //     }
        // }
        // if (col.field == 'id_estagio') {
        //     return {
        //         headerAlign: "center",
        //         groupId:col.field ,
        //         headerName: total?.id_estagio?.values ? String(total?.id_estagio?.values?.length) : '0',
        //         children: [{ field: 'id_estagio' }],
        //     }
        // }
        // if (col.field == 'motivo') {
        //     return {
        //         headerAlign: "center",
        //         groupId:col.field ,
        //         headerName: total?.motivo?.values ? String(total?.motivo?.values?.length) : '0',
        //         children: [{ field: 'motivo' }],
        //     }
        // }
        if (col.field == 'saldo') {
            return {
                headerAlign: "center",
                groupId:col.field ,
                headerName: total?.saldo?.total ? "R$ " + parseFloat(total?.saldo?.total).toLocaleString("pt-Br") : "R$ " + parseFloat('0').toLocaleString("pt-Br"),
                children: [{ field: 'saldo' }],
            }
        }

        return {
            headerAlign: "center",
            groupId:col.field ,
            headerName: '',
            children: [{ field: col.field }],
        }
    })

    return {
        total,
        columnGroupingModel
    }
}